module.exports = __webpack_public_path__ + "static/media/kids_29.29577c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_29.jpg
// module id = 5885
// module chunks = 0